<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="MaintenanceId"
      ref="list"
      unit="加工阶段"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="getDataFunc"
      :query-params="params"
      urlHash="basedata/inventory/process_stage"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/facility/repair/list.json";
import tableParam from "@/data/facility/repair/query.json";
import formColumn from "@/data/facility/repair/form.json";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/stock/machiningStage").default,
      params: {
        // EquipmentName: null,
        // Status: null,
      },
    };
  },
  methods: {
    getDataFunc(params = {}) {
      return new Promise((resolve) => {
        this.api.list({ ...params, IsFullStage: true}).then((res) => { // <!-- h -->
          res.Data.forEach((item) => {
            item.ClaimConsumables = item.ClaimConsumables == true ? "是" : "否";
            item.ConsumablesClaim = item.ConsumablesClaim == true ? "是" : "否";
            item.IsRetreat = item.IsRetreat == true ? "是" : "否";
            item.Status = item.Status == true ? "是" : "否";
            item.UseProcess = item.UseProcess == true ? "是" : "否";
          });
          resolve(res);
        });
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>